import { BackendUser } from '../user/userService';

/**
 * Check if user has a specific permission
 * Admins always return true
 * Staff must have the permission or all_permissions
 */
export function hasPermission(
  permission: string,
  user: BackendUser | null
): boolean {
  if (!user) return false;

  // Admins have all permissions
  if (user.role === 'admin') return true;

  // Staff check
  const permissions = user.permissions || [];
  return (
    permissions.includes(permission) ||
    permissions.includes('all_permissions')
  );
}
